/**
 *
 * Created Date: 2019-06-25, 10:13:09 (zhenliang.sun)
 * Last Modified: 2019-06-25, 10:14:23 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

export default class WatchStatusInfo {
  constructor() {
    this.open = false;
    this.uniqueId = 0;
    this.createTime = 0;
  }
}
